export const FILTER_TYPE = {
  TEXT: 'TEXT',
  SELECT: 'SELECT',
  MULTISELECT: 'MULTISELECT',
  NUMBER: 'NUMBER',
  DATE: 'DATE'
};

export const FILTER_DELAY = 500;



// WEBPACK FOOTER //
// ./packages/react-bootstrap-table2-filter/src/const.js